import { useState } from "react";
import { toast } from "sonner";
import { usFederalHolidays } from "@/lib/holidays";

export function HolidayDatesEditor({ value = [], onChange, idPrefix = "holiday" }) {
  const [d, setD] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());

  const add = () => {
    if (!d) return;
    if (!value.includes(d)) onChange([...value, d].sort());
    setD("");
  };
  const addFederal = () => {
    const merged = [...new Set([...value, ...usFederalHolidays(year)])].sort();
    const added = merged.length - value.length;
    onChange(merged);
    toast.success(added > 0
      ? `Added ${added} US federal holiday${added === 1 ? "" : "s"} for ${year}.`
      : `All ${year} federal holidays were already on the list.`);
  };

  return (
    <div>
      <div className="flex flex-wrap items-center gap-2">
        <input type="date" value={d} onChange={(e) => setD(e.target.value)}
          data-testid={`${idPrefix}-date-input`}
          className="h-9 px-2 border border-slate-300 rounded-md text-sm" />
        <button type="button" data-testid={`${idPrefix}-add-date`} onClick={add}
          className="h-9 px-3 border border-slate-300 rounded-md text-sm font-semibold hover:bg-slate-50">Add date</button>
        <select value={year} onChange={(e) => setYear(Number(e.target.value))}
          data-testid={`${idPrefix}-year-select`}
          className="h-9 px-2 border border-slate-300 rounded-md text-sm bg-white">
          {[0, 1, 2].map((i) => {
            const y = new Date().getFullYear() + i;
            return <option key={y} value={y}>{y}</option>;
          })}
        </select>
        <button type="button" data-testid={`${idPrefix}-add-federal`} onClick={addFederal}
          className="h-9 px-3 border border-amber-300 bg-amber-50 text-amber-800 rounded-md text-sm font-semibold hover:bg-amber-100">
          + All US federal holidays
        </button>
      </div>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-2" data-testid={`${idPrefix}-dates-list`}>
          {value.map((x) => (
            <span key={x} className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-amber-50 border border-amber-200 text-amber-800 text-xs font-semibold">
              {x}
              <button type="button" data-testid={`${idPrefix}-remove-${x}`}
                onClick={() => onChange(value.filter((v) => v !== x))}
                className="text-amber-600 hover:text-rose-600 font-bold">×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
